import axios, { type AxiosResponse } from 'axios'

import { type Locale } from '@lib/language'
import {
  type SanityCombinedListingProductResponse,
  type ShopifyCombinedListingProductCreatePayload,
  type ShopifyCombinedListingProductCreateResponse,
} from './types'

/**
 * Fetches combined listing product by its ID, also caches results.
 */
export const getCombinedListingProductWithCache = async (
  locale: Locale,
  productId: number,
) => {
  const response = await axios.get<SanityCombinedListingProductResponse>(
    '/api/sanity/combined-listing-product',
    {
      params: {
        product_id: productId,
      },
      headers: {
        'Content-Type': 'application/json',
        'X-Locale': locale,
      },
    },
  )

  if (response.status !== 200) {
    throw new Error(response.data.error)
  }

  if (!response.data.product) {
    throw new Error('Product not found')
  }

  return response.data.product
}

/**
 * Sends a request to create a Shopify combined listing product.
 */
export const createCombinedListingProduct = async (
  locale: string,
  productIds: number[],
  frameSize: string,
  artworkSize?: string,
) => {
  const payload: ShopifyCombinedListingProductCreatePayload = {
    product_ids: productIds,
    frame_size: frameSize,
    artwork_size: artworkSize,
  }

  const response = await axios.post<
    ShopifyCombinedListingProductCreateResponse,
    AxiosResponse<ShopifyCombinedListingProductCreateResponse>,
    string
  >('/api/shopify/combined-listing-product-create', JSON.stringify(payload), {
    headers: {
      'Content-Type': 'application/json',
      'X-Locale': locale,
    },
  })

  if (response.status !== 200) {
    throw new Error(JSON.stringify(response.data))
  }

  return response.data
}
